export default __webpack_public_path__ + "static/media/weatherapp.5dd5c799.gif";